export default {
    clients: '{{count}} Client(s)',
    createdDocuments: '{{count}} Created Document(s)',
    message:
        'The following data will be permanently deleted and cannot be recovered once deleted.',
    noLongerAbleToUseMakeLeaps: 'You will no longer be able to use MakeLeaps.',
    receivedDocuments: '{{count}} Received Document(s)',
    submitButton: 'Confirm Delete',
    teamMemberAccounts: 'Team member user accounts that will also be deleted:',
    teamMembers: '{{count}} Team Member(s)',
    title: 'Deletion',
    yourCompany: 'Your company: {{company}}',
    yourUserAccount: 'Your user account:',
};
